import { unstable_unsupportedProp as unsupportedProp } from '@material-ui/utils';
export default unsupportedProp;